import styled from '@emotion/styled'

export const FormFieldsWrapper = styled.div`
  width: 50%;
  position: relative;
`
